import { io } from 'socket.io-client';
import toast from 'react-hot-toast';
import { playInAppNotificationSound } from './notificationSoundService';

let socket = null;
const notificationListeners = new Set();

/** Subscribe to in-app notification socket events. Returns unsubscribe. */
export function onNotification(fn) {
  notificationListeners.add(fn);
  return () => notificationListeners.delete(fn);
}

function dispatchNotification(data) {
  for (const fn of notificationListeners) {
    try { fn(data); } catch (e) { console.error('[socket] notification listener failed:', e); }
  }
}

/**
 * Connect this tab's Socket.io client. Each browser tab keeps its own module
 * instance / socket — concurrent tabs are allowed and each joins the same
 * user room on the server.
 */
export function connectSocket(token) {
  if (socket?.connected) return socket;

  // Same origin so Socket.io goes through the Vite proxy (local or ngrok).
  const baseUrl = import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, '') || window.location.origin;
  socket = io(baseUrl, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 3000,
  });

  socket.on('connect', () => {
    console.log('[socket] connected');
  });

  // Audit watcher events
  socket.on('audit:complete', (data) => {
    toast.success(data.message || 'Technical SEO Audit is ready!', { duration: 8000 });
  });

  socket.on('audit:failed', (data) => {
    toast.error(data.message || 'Audit crawl failed', { duration: 8000 });
  });

  socket.on('notification', (data) => {
    playInAppNotificationSound();
    dispatchNotification(data);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket() {
  return socket;
}
